<app-loader />
<p-toast
  position="top-center"
  styleClass="ssrk-toast"
  [breakpoints]="toastBreakpoints"
/>
<router-outlet />
